<template>
  <div class="comparison-group-selector-modal">
    <PulsModal
      :id="id"
      :title="$t('groupsComparison.selectTableGroups')"
      size="lg"
      :BootstrapModalClass="bootstrapModal"
      :onOk="() => handleApply()"
      :onCancel="() => handleCancel()"
      :okTitle="$t('general.ok')"
      :okDisabled="localSelection.length === 0"
      :cancelTitle="$t('general.cancel')"
    >
      <template #modal-body>
        <p class="text-muted fs-7 mb-5">
          {{ $t('groupsComparison.groupSelectorDescription') }}
        </p>
        <div class="d-flex gap-2">
          <Treeselect
            ref="treeselect"
            :key="treeselectKey"
            :modelValue="localSelection"
            :options="groupOptions"
            :multiple="true"
            :clearable="true"
            :flat="true"
            :auto-select-ancestors="false"
            :auto-deselect-ancestors="false"
            :auto-deselect-descendants="false"
            :auto-select-descendants="false"
            :searchable="true"
            value-consists-of="ALL"
            :limit="20"
            open-direction="below"
            :placeholder="$t('groupsComparison.filter.findGroups')"
            @update:model-value="handleSelectionChange"
          >
          </Treeselect>
          <button
            v-if="localSelection.length === 0"
            class="btn btn-link btn-sm px-0"
            type="button"
            :disabled="groupOptions.length === 0"
            @click="handleSelectAll"
          >
            <span class="d-flex align-items-center">
              <i class="bi bi-check2-all me-1 ms-3"> </i>
              {{ $t('groupsComparison.selectAll') }}
            </span>
          </button>
        </div>
      </template>
    </PulsModal>
  </div>
</template>

<script>
import Treeselect from '@cholakovdev/vue3-treeselect'
import '@cholakovdev/vue3-treeselect/dist/vue3-treeselect.css'
import { Modal } from 'bootstrap'

export default {
  name: 'ComparisonGroupSelectorModal',
  components: {
    Treeselect
  },
  props: {
    id: {
      type: String,
      default: 'comparison-group-selector-modal'
    },
    groups: {
      type: Array,
      default: () => []
    },
    treeifiedGroups: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update-selected-groups'],
  data() {
    return {
      localSelection: [],
      treeselectKey: 0,
      lastAppliedSelection: []
    }
  },
  computed: {
    allGroupIds() {
      return this.groups.map((g) => g.name)
    },
    bootstrapModal() {
      return Modal
    },
    groupOptions() {
      const cleanTree = (nodes) => {
        return nodes.map((node) => {
          const cleaned = { ...node }
          if (cleaned.children && cleaned.children.length > 0) {
            cleaned.children = cleanTree(cleaned.children)
          } else {
            cleaned.children = undefined
          }
          return cleaned
        })
      }

      return cleanTree(this.treeifiedGroups)
    }
  },
  mounted() {
    document.addEventListener(
      `show.puls.modal#${this.id}`,
      this.handleModalOpen
    )
  },
  beforeUnmount() {
    document.removeEventListener(
      `show.puls.modal#${this.id}`,
      this.handleModalOpen
    )
  },
  methods: {
    forceTreeselectRerender() {
      this.treeselectKey += 1
    },
    getSelectionForModal() {
      const allIds = this.allGroupIds
      if (!allIds.length) {
        return []
      }
      const validLastSelection = (this.lastAppliedSelection || []).filter(
        (id) => allIds.includes(id)
      )
      if (validLastSelection.length > 0) {
        return validLastSelection
      }
      return allIds
    },
    handleModalOpen() {
      this.localSelection = this.getSelectionForModal()
      this.forceTreeselectRerender()
    },
    handleSelectionChange(newSelection) {
      this.localSelection = Array.isArray(newSelection) ? newSelection : []
    },
    handleSelectAll() {
      this.$refs.treeselect?.closeMenu()
      if (!this.allGroupIds.length) {
        this.localSelection = []
        return
      }
      this.localSelection = [...this.allGroupIds]
      this.forceTreeselectRerender()
    },
    handleApply() {
      const uniqueSelection = [
        ...new Set(this.localSelection.filter((value) => value))
      ]
      this.lastAppliedSelection =
        uniqueSelection.length > 0 ? uniqueSelection : this.allGroupIds
      this.$emit('update-selected-groups', uniqueSelection)
      this.dispatchHideEvent()
    },
    handleCancel() {
      this.dispatchHideEvent()
    },
    dispatchHideEvent() {
      const event = new Event(`hide.puls.modal#${this.id}`, {
        bubbles: true
      })
      document.dispatchEvent(event)
    }
  }
}
</script>
